import React, { useCallback, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export interface Fields {
  id: string;
  label: string;
  // required?: boolean;
  // autoComplete?: string;
  // autoFocus?: boolean;
  type?: 'text' | 'password' | 'tel' | 'number' | 'email';
  // default?: string;
  validator: any;
}

interface FormProps {
  fields: Fields[];
  children: React.ReactNode;
  loading: boolean;
  submitButtonTextKey: string;
  onSubmit: (data: any) => void;
  exposeGetValues?: (getValues: any) => void;
}

const FormEL: React.FC<FormProps> = ({
  fields,
  children,
  loading,
  submitButtonTextKey,
  onSubmit,
  exposeGetValues
}) => {
  const validators: { [key: string]: any } = {};

  fields.forEach((field) => {
    //console.log(field);
    validators[field.id] = field.validator;
  });

  const schema = yup.object(validators).required();

  const { handleSubmit, formState, control, getValues } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const memorizedGetValues = useCallback(() => {
    return getValues();
  }, [getValues]);
  
  useEffect(() => {
    if (exposeGetValues && formState.isDirty) { // Only expose values if form has changed
      exposeGetValues(memorizedGetValues());
    }
  }, [exposeGetValues, formState, memorizedGetValues]);

  const onSubmitHandler = (data: any) => {
    console.log(data);
    // console.log(errors);
    console.log(formState);
    console.log(schema);
    onSubmit(data);
  };

  const { t } = useTranslation();
  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit(onSubmitHandler)}
      sx={{ width: '100%' }}
    >
      <Stack spacing={2.5}>
        {fields.map(({ label, type, id }, index) => (
          <Controller
            key={index}
            control={control}
            name={id}
            defaultValue=""
            render={({ field: { onChange, value, ref } }) => (
              <TextField
                label={t(label)}
                value={value}
                inputRef={ref}
                onChange={onChange}
                error={!!formState.errors[id]}
                helperText={formState.errors[id]?.message as string}
                placeholder={`Insert ${id}`}
                type={type || 'text'}
                fullWidth
                variant="outlined"
                size="medium"
                sx={{
                  '& .MuiInputBase-root': {
                    height: '56px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: '1rem',
                  }
                }}
              />
            )}
          />
        ))}
        {children}
        <Button
          variant="contained"
          type="submit"
          disabled={loading || !formState.isValid}
          fullWidth
          size="large"
          sx={{ 
            py: 1.75,
            fontSize: '1rem',
            fontWeight: 500,
            mt: 1
          }}
        >
          {loading ? 'Loading...' : t(submitButtonTextKey)}
        </Button>
      </Stack>
    </Box>
  );
};

export default FormEL;
